import React, { Fragment } from "react";

interface IStep {
  step: number;
}

function MenuAside({ step }: IStep) {
  return (
    <Fragment>
      <aside>
        <h2>Etapas:</h2>
        <nav>
          <ol>
            <li className={step > 0 ? "active" : ""}>Dados de Adesão</li>
            <li className={step > 1 ? "active" : ""}>Dados Cadastrais</li>
            <li className={step > 2 ? "active" : ""}>Beneficiários</li>
            <li className={step > 3 ? "active" : ""}>Documentos</li>
            <li className={step > 4 ? "active" : ""}>Conclusão</li>
          </ol>
        </nav>
      </aside>
    </Fragment>
  );
}
export default MenuAside;
